import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function getRetrieveList (params) {
  return fetch.post(URL.getRetrieveList, params, 'noFormData');
}

export function findRetrieve (params) {
  return fetch.post(URL.findRetrieve, params, 'noFormData');
}

export function urlMonitor (params) {
  return fetch.post(URL.urlMonitor, params, 'noFormData');
}

export function updateRetrieve (params) {
  return fetch.post(URL.updateRetrieve, params, 'noFormData');
}

export function online (params) {
  return fetch.post(URL.online, params, 'noFormData');
}

export function offline (params) {
  return fetch.post(URL.offline, params, 'noFormData');
}

export function createRetrieve (params) {
  return fetch.post(URL.createRetrieve, params, 'noFormData');
}

export function deleteRetrieve (params) {
  return fetch.post(URL.deleteRetrieve, params, 'noFormData');
}

export function getPackageList (params) {
  return fetch.post(URL.getPackageList, params, 'noFormData');
}

export function createPackage (params) {
  return fetch.post(URL.createPackage, params, 'noFormData');
}

export function updatePackage (params) {
  return fetch.post(URL.updatePackage, params, 'noFormData');
}

export function deletePackage (params) {
  return fetch.post(URL.deletePackage, params, 'noFormData');
}

export function pushPackage (params) {
  return fetch.post(URL.pushPackage, params, 'noFormData');
}

export function findPackage (params) {
  return fetch.post(URL.findPackage, params, 'noFormData');
}

export function pushRetrieveList (params) {
  return fetch.post(URL.pushRetrieveList, params, 'noFormData');
}

export function upgradeRetrieveList (params) {
  return fetch.post(URL.upgradeRetrieveList, params, 'noFormData');
}

export function createPackageVersion (params) {
  return fetch.post(URL.createPackageVersion, params);
}

export function deletePackageVersion (params) {
  return fetch.post(URL.deletePackageVersion, params, 'noFormData');
}



// WEBPACK FOOTER //
// ./src/api/modules/upgrade.js